// extracted by mini-css-extract-plugin
export var circle = "_fe-1";
export var exitConfirmationModal = "_fe-5";
export var iframe = "_fe-0";
export var offline = "_fe-3";
export var online = "_fe-2";
export var workstationSelectError = "_fe-4";